var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTumblr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 24.6667C28 26.508 26.508 28 24.6667 28H7.33333C5.49267 28 4 26.508 4 24.6667V7.33333C4 5.492 5.49267 4 7.33333 4H24.6667C26.508 4 28 5.492 28 7.33333V24.6667Z",
    fill: "#01579B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3337 23.2606C21.3337 23.324 21.309 23.3833 21.261 23.4253C21.2023 23.4766 19.8157 24.6666 16.6317 24.6666C12.8143 24.6666 12.703 20.394 12.703 19.906L12.667 14.6666H10.8857C10.7643 14.6666 10.667 14.5686 10.667 14.4473V12.38C10.667 12.29 10.7223 12.2073 10.8057 12.174C10.8403 12.1606 14.253 10.7853 14.253 7.55198C14.253 7.42998 14.3503 7.33264 14.471 7.33264H16.4483C16.5697 7.33331 16.667 7.43064 16.667 7.55264V12H20.447C20.5683 12 20.667 12.0973 20.667 12.2186V14.4486C20.667 14.5706 20.5683 14.6666 20.447 14.6666H16.667V19.8073C16.667 19.8746 16.8777 21.4866 18.507 21.4866C19.8557 21.4866 20.9877 20.7906 21.0003 20.7833C21.067 20.7406 21.1517 20.7393 21.2223 20.7773C21.291 20.8153 21.3337 20.8893 21.3337 20.97V23.2606Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTumblr);
export default __webpack_public_path__ + "static/media/tumblr.ba9ad81cb03beab2bf03730390f2f1a7.svg";
export { ForwardRef as ReactComponent };